<template>
    <div class="know-how-detail">
        <title-screen title ="2"></title-screen>
        <div class="know-how-name"><p>{{name}}</p></div>
        <div class="know-how-content">
            <div class="ck-content" v-html="content"></div>
        </div>
        <div class="contact">
          <div class="btn-contact">
            <el-button class="el-button-big gtm_yonde_inquiry_yonde" @click="redirectContact"><span class="gtm_yonde_inquiry_yonde">より具体的に相談したい方はこちら</span></el-button>
          </div>
        </div>
        <div class="know-how-content-bottom">
            <el-button @click="handleBack" class="">{{ $t("commons.back") }}</el-button>
        </div>
    </div>
</template>
<script>
import knowhow from '@/api/knowhow/know-how-cl.js'
import TitleScreen from '../../../../components/common/TitleScreen'
export default {
  components: { TitleScreen },
  data () {
    return {
      name: '',
      content: ''
    }
  },
  created () {
    const categoryId = this.$route.params.id
    knowhow.referKnowHow(categoryId).then(response => {
      this.name = response.data.data.name
      this.content = response.data.data.content
    })
  },
  methods: {
    handleBack () {
      this.$router.push({ name: 'category' })
    },
    redirectContact () {
      window.open('/contact', '_blank')
    }
  }
}
</script>
<style>
    .know-how-detail {
        /*margin-top: 5%;*/
        width: 100%;
    }
    .know-how-name p {
        /*color: #000000;*/
        font-size: 20px;
        padding-left: 1em;
        padding-right: 1em;
        font-weight: bold;
    }
    .know-how-content {
        padding-left: 1em;
        margin-top: 20px;
        background: #ffffff;
    }
    .know-how-content img {
      width: 100%;
    }
    .know-how-content a {
      color: #3a8ee6 !important;
    }
    .know-how-content-bottom {
        margin-top: 20px;
        text-align: center;
    }
    .contact {
      padding-left: 1em;
      margin-top: 2em;
    }
    .link-contact {
      font-size: 16px;
      text-decoration: underline;
      color: blue;
    }
    .link-contact :hover {
      cursor: pointer;
    }
    .btn-contact {
      margin-top: 20px;
      text-align: center;
    }
    .btn-contact button {
      padding: 1em !important;
    }
</style>
